import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import CommonChip from "../../../common_components/CommonChip";
// Derive initials from a name when the API didn't supply them.
const getInitials = (name = "") => name.trim().split(/\s+/).filter(Boolean).map((n) => n[0]).join("").toUpperCase();
/**
 * Account Manager avatars, rendered side by side (slightly overlapping) exactly
 * like the Account Performance table: a centered, no-gap flex row of circle
 * chips. Shows the first two (initials + full-name tooltip), then a "+N" chip
 * whose tooltip lists the remaining names.
 */
const AmBadges = ({ managers }) => {
    if (!managers || managers.length === 0) {
        // return <Box component="span" sx={{ color: "#98A2B3" }}>-</Box>;
        return (_jsx(CommonChip, { label: 'NA', tooltip: 'Not Available', renderType: "circle", className: `circle manager-circle` }));
    }
    const visible = managers.slice(0, 2);
    const extra = managers.slice(2);
    return (_jsx(Box, { sx: { display: "flex", justifyContent: "center" }, children: _jsxs(Box, { sx: { display: "flex", position: "relative", zIndex: 1 }, children: [visible.map((m, idx) => {
                    const label = m.initials || getInitials(m.name);
                    return (_jsx(CommonChip, { label: label, tooltip: m.name || label, renderType: "circle", index: idx, className: `circle manager-circle ${idx === 0 ? "first" : ""} ${label === "NA" ? "na" : "ok"}` }, `${label}-${idx}`));
                }), extra.length > 0 && (_jsx(CommonChip, { label: `+${extra.length}`, renderType: "circle", index: 2, className: "circle extra-circle manager-circle", tooltip: _jsx(Box, { sx: { background: "black", borderRadius: "8px", overflow: "hidden", minWidth: 160 }, children: extra.map((m, i) => (_jsx(Box, { sx: {
                                px: 1, py: 1, fontSize: "14px", textTransform: "capitalize",
                                borderBottom: i !== extra.length - 1 ? "1px solid rgba(255,255,255,0.5)" : "none",
                            }, children: m.name || m.initials }, `${m.name}-${i}`))) }) }))] }) }));
};
export default AmBadges;
